
import { Component, Inject, Vue } from 'vue-property-decorator';
import { OnBeforeDestroy, OnCreated } from '@/util/vue/vueCallbacks';
import AuthRepository from '@/repositories/AuthRepository';
import { Subscription } from 'rxjs';
import LoginScaffold from '@/components/scaffolds/LoginScaffold.vue';
import GlobalState from '@/util/GlobalState';
import SimpleFormValidationHandler from '@/util/form/SimpleFormValidationHandler';

@Component({
    components: { LoginScaffold },
})
export default class LoginScreen extends Vue implements OnCreated, OnBeforeDestroy {
    public email = '';
    public password = '';
    public error = false;
    public loading = false;
    public afterLogout = false;
    public validationHandler = new SimpleFormValidationHandler(['email', 'password']);

    @Inject() private readonly globalState!: GlobalState;
    @Inject() private readonly authRepository!: AuthRepository;
    private authSubscription = new Subscription();
    private userSubscription = new Subscription();

    public get basicRules(): ((input: any) => boolean | string)[] {
        return [(input) => !!input || this.$t('validation.NotBlank').toString()];
    }

    public get loginProviders() {
        return this.authRepository.getLoginProviders();
    }

    public created(): void {
        this.validationHandler.translator = this.$i18n;
        if (this.$route.name === 'logout') {
            // TODO: Verify logout?
            this.afterLogout = true;
        }
        this.userSubscription = this.globalState.verifiedUser.subscribe((user) => {
            if (user) {
                this.$router.push({ name: 'home' });
            }
        });
    }

    public beforeDestroy(): void {
        this.authSubscription.unsubscribe();
        this.userSubscription.unsubscribe();
    }

    public onRetry() {
        this.afterLogout = false;
    }

    public onSubmit(): void {
        if (this.loading) {
            return;
        }
        this.loading = true;
        this.authSubscription.unsubscribe();
        this.validationHandler.clearValidation();
        this.authSubscription = this.authRepository
            .login(this.email, this.password)
            .subscribe((loginResponseResource) => {
                if (loginResponseResource.isSuccess && loginResponseResource.data) {
                    if (loginResponseResource.data.redirectUri) {
                        window.location.href = loginResponseResource.data.redirectUri;
                    } else {
                        this.globalState.toast(this.$t('general.communicationError').toString());
                        this.loading = false;
                    }
                } else if (loginResponseResource.isError) {
                    const validationError = this.validationHandler.handleErrorResponse(loginResponseResource.error);
                    if (validationError) {
                        this.globalState.toast(this.$t('login.validationError').toString());
                    } else {
                        this.globalState.toast(this.$t('general.communicationError').toString());
                    }
                    this.loading = false;
                }
            });
    }
}
